import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import DownloadNotification from "../components/download_notification";
import { selectDefaultReducer } from "../redux/default/selectors";

const DownloadNotificationContainer = () => {
  const dispatch = useDispatch();

  const {
    downloading,
    translations
  } = useSelector(selectDefaultReducer);

  const onCloseClick = () => dispatch(Action.closeDownloadNotification());

  return (
    <DownloadNotification 
      downloading={downloading}
      translations={translations}
      onCloseClick={onCloseClick}
    />
  )
}

export default DownloadNotificationContainer;